// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: 'All Exam View',
    path: '/user/currentExams',
    icon: getIcon('eva:pie-chart-2-fill'),
  },
  {
    title: 'My Profile',
    path: '/user/profile',
    icon: getIcon('eva:people-fill'),
  },
  {
    title: 'Mobile OMR Upload',
    path: '/user/mobileOmrScan',
    icon: getIcon('eva:people-fill'),
  },

  // {
  //   title: 'TEMP',
  //   path: '/user/checkFilledOmrAnswers',
  //   icon: getIcon('eva:people-fill'),
  // },
];

export default navConfig;
